<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Highlights · Auf einen Blick</p>

      <h2 class="presentation-page__title">Was uns auszeichnet</h2>

      <p class="presentation-page__text">
        Sechs Punkte, an denen Sie uns von jedem anderen PV-Anbieter unterscheiden können.
      </p>

      <div class="presentation-page__highlights">
        <article
          v-for="highlight in highlights"
          :key="highlight.heading"
          class="presentation-page__highlight-card"
        >
          <div class="presentation-page__highlight-icon" aria-hidden="true">
            <i :class="['fa', highlight.icon]"></i>
          </div>
          <h3 class="presentation-page__highlight-heading">{{ highlight.heading }}</h3>
          <p class="presentation-page__highlight-text">{{ highlight.text }}</p>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage03',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      highlights: [
        {
          icon: 'fa-certificate',
          heading: '20+ Jahre Erfahrung',
          text:
            'Photovoltaik-Installation und Projektabwicklung seit zwei Jahrzehnten in Deutschland.',
        },
        {
          icon: 'fa-check-circle',
          heading: '9.000+ realisierte Projekte',
          text:
            'Von der privaten Dachanlage bis zur Multi-MW-Freifläche — alles erfolgreich abgeschlossen.',
        },
        {
          icon: 'fa-line-chart',
          heading: 'Skalierbar B2B & B2C',
          text:
            'Freiflächen-, Hallendach- und BESS-Projekte mit MW-Potenzial neben Privatkundengeschäft.',
        },
        {
          icon: 'fa-wrench',
          heading: 'Eigene Montageteams',
          text:
            'Qualifizierte Mitarbeiter im Haus — reduziert Ausführungs- und Terminrisiken signifikant.',
        },
        {
          icon: 'fa-cloud',
          heading: 'Digitale End-to-End-Prozesse',
          text: 'RETIS-Plattform für volle Transparenz von Lead bis Inbetriebnahme und O&M.',
        },
        {
          icon: 'fa-building',
          heading: 'Konzernanbindung',
          text: 'Tochter der Salvia Gebäudetechnik — Teil der börsennotierten Eiffage-Gruppe.',
        },
      ],
    };
  },
};
</script>
